import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';

import { Loader } from '@/components/Loader';

export function ProtectedRoute({ roles, children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Loader variant="full" />
      </div>
    );
  }
  if (!user) {
    // Route to the appropriate login form based on the requested URL
    let loginPath = '/connexion/bailleur';
    if (location.pathname.startsWith('/admin')) loginPath = '/connexion/admin';
    else if (location.pathname.startsWith('/agent')) loginPath = '/connexion/admin';
    else if (location.pathname.startsWith('/locataire')) loginPath = '/connexion/locataire';
    return <Navigate to={loginPath} replace state={{ from: location }} />;
  }
  if (roles && !roles.includes(user.role)) {
    // route them to their default zone
    if (user.role === 'platform_owner' || user.role === 'admin') return <Navigate to="/admin" replace />;
    if (user.role === 'agent') return <Navigate to="/agent" replace />;
    if (user.role === 'bailleur') return <Navigate to="/bailleur" replace />;
    if (user.role === 'locataire') return <Navigate to="/locataire" replace />;
    return <Navigate to="/" replace />;
  }
  if (user.must_change_password && location.pathname !== '/change-password') {
    return <Navigate to="/change-password" replace />;
  }
  return children;
}
